import { PickSharePayloadData, ShareType } from "../types";

const getUniqueTypes = <T extends ShareType[]>(data: PickSharePayloadData<T>) => {
	const uniqueTypes = new Set<T[number]>();
	for (const { type } of data) {
		uniqueTypes.add(type);
	}
	return Array.from(uniqueTypes).sort() as T;
};

export default getUniqueTypes;
